import styled from 'styled-components';
import { css } from 'styled-components';
import { ButtonWithDemoExitConfirmation } from '../../DemoExitConfirmation';
import MenuItem from '../../Menu/components/MenuItem';
import { getTypographyStylesV2 } from 'breadcrumbs-ui/components/Text';
import ExternalLink from '../../icons/ExternalLink';
import LinkBadge from '../../LinkBadge';
import { LinkBadgeType } from '../../VerticalNav/hooks/useLinkBadgeData';
import { useTranslation } from '../../../hooks/useNavConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledMenuItem = styled(MenuItem)(({
  theme,
  dividerAbove,
  spaceAbove
}) => css(["list-style-type:none !important;", " a{margin:", ";padding:", " ", " !important;.accounts__primary-text-container{display:flex;align-items:center;gap:", ";}.accounts__primary-text{color:", " !important;display:flex;align-items:center;", " gap:", ";}.accounts__primary-text-badge{display:flex;flex:1;justify-content:flex-end;}.accounts__secondary-text{color:", " !important;display:flex;align-items:center;", "}&:hover,&:focus{text-decoration:none;.accounts__primary-text{text-decoration:underline;.accounts__primary-text-badge{text-decoration:none !important;}}}svg{fill:", " !important;}}"], dividerAbove && css(["&::before{content:'';display:block;width:100%;height:1px;background-color:", ";margin:", " 0 !important;}"], theme.color['border-core-default'], theme.space['250']), spaceAbove ? `${theme.space['250']} 0 0 !important` : '0 !important', theme.space['100'], theme.space['500'], theme.space['50'], theme.color['text-core-default'], getTypographyStylesV2(theme, 'body-125'), theme.space['50'], theme.color['text-core-subtle'], getTypographyStylesV2(theme, 'detail-100'), theme.color['text-core-default']));
export const AccountExtraLink = ({
  id,
  link,
  linkText,
  secondaryText,
  dividerAbove = false,
  spaceAbove = false,
  isNewItem = false,
  isExternal
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(ButtonWithDemoExitConfirmation, {
    component: StyledMenuItem,
    dividerAbove: dividerAbove,
    spaceAbove: spaceAbove,
    id: id,
    href: link,
    target: isExternal ? '_blank' : undefined,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "accounts__primary-text-container",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "accounts__primary-text",
        children: [linkText, isExternal && /*#__PURE__*/_jsx(ExternalLink, {})]
      }), isNewItem && /*#__PURE__*/_jsx("div", {
        className: "accounts__primary-text-badge",
        children: /*#__PURE__*/_jsx(LinkBadge, {
          type: LinkBadgeType.new,
          text: t('nav.badges.new')
        })
      })]
    }), secondaryText && /*#__PURE__*/_jsx("div", {
      className: "accounts__secondary-text",
      children: secondaryText
    })]
  });
};